import { PaypleProvider } from '../../subscription';
import { PlanPaymentForm } from '../PlanPaymentForm';
import { PlanPaymentForeignOnetimeSubmit, PlanPaymentSubmit } from '../PlanPaymentSubmit';
import { PlanPaymentSummary } from '../PlanPaymentSummary';
import { PlanPaymentLayout } from '../shared';
import { PlanTemplateType } from '../types';
import { usePlanPaymentFormContext } from './Providers';
const ForeignPaymentContentInner = () => {
  const {
    watch
  } = usePlanPaymentFormContext();
  const planTemplateType = watch('planTemplateType');
  return <PlanPaymentLayout.Root data-sentry-element="unknown" data-sentry-component="ForeignPaymentContentInner" data-sentry-source-file="ForeignPaymentContent.tsx">
      <PlanPaymentLayout.Content data-sentry-element="unknown" data-sentry-source-file="ForeignPaymentContent.tsx">
        <PlanPaymentForm data-sentry-element="PlanPaymentForm" data-sentry-source-file="ForeignPaymentContent.tsx" />
        <PlanPaymentSummary data-sentry-element="PlanPaymentSummary" data-sentry-source-file="ForeignPaymentContent.tsx" />
      </PlanPaymentLayout.Content>
      <PlanPaymentLayout.Footer data-sentry-element="unknown" data-sentry-source-file="ForeignPaymentContent.tsx">
        <div className="w-[990px] min-w-[990px] px-[60px] py-[14px]">
          {planTemplateType === PlanTemplateType.PRODUCT_ONETIME ? <PlanPaymentForeignOnetimeSubmit /> : <PlanPaymentSubmit />}
        </div>
      </PlanPaymentLayout.Footer>
    </PlanPaymentLayout.Root>;
};
export const ForeignPaymentContent = () => {
  return <PaypleProvider data-sentry-element="PaypleProvider" data-sentry-component="ForeignPaymentContent" data-sentry-source-file="ForeignPaymentContent.tsx">
      <ForeignPaymentContentInner data-sentry-element="ForeignPaymentContentInner" data-sentry-source-file="ForeignPaymentContent.tsx" />
    </PaypleProvider>;
};